module.exports = __webpack_public_path__ + "static/DINWeb-Bold-5f30c5806b6b26bcc46448a5ddca9b67.eot";